<template>
  <div class="dashboard-wrap">
    <div class="dash-topbar">
      <dashboardTopBar
        :dash-tab="dashboardTab"
        :is-filter-applied="isFilterApplied"
        @resetDashFilters="resetDashFilters"
        @toggleDashFilter="toggleDashFilter"
      ></dashboardTopBar>
    </div>

    <div class="filter-drawer">
      <dashboardFilters
        ref="DashboardFilters"
        :reset="isFilterApplied"
        @getDashboardWithFilter="filterApplied"
      ></dashboardFilters>
    </div>

    <div class="dashboard-container">
      <div class="dash-action-bar"
      :class="activeTab !== 'txt-analysis'
          && activeTab !== 'overview' ? 'active-border' : ''"
      >
        <div class="filter-bar"
        :class="activeTab !== 'txt-analysis'
          && activeTab !== 'overview'
          && activeTab !== 'anonymous-snapshot' ? 'active' : ''"
        >
          <ul v-if="activeTab === 'touchpoints-snapshot' || activeTab === 'touchpoints-analysis'">
            <li class="">
              <div class="top-menu"
                :class="activeTab === 'touchpoints-snapshot' ? 'top-menu--active' : ''"
                @click="dashboardTab = 'touchpoints-snapshot';onClickDashTab()"
              >
                <div class="top-menu__icon">
                  <!-- <i class="las la-chart-pie"></i> -->
                  <i class="las la-cube"></i>
                </div>
                <div class="top-menu__title"> Snapshot </div>
              </div>
            </li>
            <li class="am-item">
              <div class="top-menu"
                :class="activeTab === 'touchpoints-analysis' ? 'top-menu--active' : ''"
                @click="dashboardTab = 'touchpoints-analysis';onClickDashTab()"
              >
                <div class="top-menu__icon">
                  <!-- <i class="las la-chart-pie"></i> -->
                  <i class="las la-digital-tachograph"></i>
                </div>
                <!-- <div class="top-menu__title"> Touchpoints analysis (heatmap)</div> -->
                <div class="top-menu__title mt-n1">Heat map</div>
              </div>
            </li>
          </ul>
          <ul
            v-if="activeTab === 'disengaged-snapshot'
            || activeTab === 'disengaged-emp-to-meet'
            || activeTab === 'disengaged-sentiment-analysis'"
          >
            <li class="">
              <div class="top-menu"
                :class="activeTab === 'disengaged-snapshot' ? 'top-menu--active' : ''"
                @click="dashboardTab = 'disengaged-snapshot';onClickDashTab()"
              >
                <div class="top-menu__icon">
                  <!-- <i class="las la-chart-pie"></i> -->
                  <i class="las la-cube"></i>
                </div>
                <div class="top-menu__title"> Snapshot </div>
              </div>
            </li>
            <li class="am-item">
              <div class="top-menu"
                :class="activeTab === 'disengaged-emp-to-meet' ? 'top-menu--active' : ''"
                @click="dashboardTab = 'disengaged-emp-to-meet';onClickDashTab()"
              >
                <div class="top-menu__icon">
                  <!-- <i class="las la-chart-pie"></i> -->
                  <i class="las la-users"></i>
                </div>
                <div class="top-menu__title"> Employees to meet </div>
              </div>
            </li>
            <li class="am-item">
              <div class="top-menu"
                :class="activeTab === 'disengaged-sentiment-analysis' ? 'top-menu--active' : ''"
                @click="dashboardTab = 'disengaged-sentiment-analysis';onClickDashTab()"
              >
                <div class="top-menu__icon">
                  <!-- <i class="las la-chart-pie"></i> -->
                  <i class="lab la-searchengin"></i>
                </div>
                <div class="top-menu__title"> Sentiment analysis </div>
              </div>
            </li>
          </ul>
          <ul v-if="activeTab === 'anonymous-snapshot' || activeTab === 'anonymous-message'">
            <li class="">
              <div class="top-menu"
                :class="activeTab === 'anonymous-snapshot' ? 'top-menu--active' : ''"
                @click="dashboardTab = 'anonymous-snapshot';onClickDashTab()"
              >
                <div class="top-menu__icon">
                  <!-- <i class="las la-chart-pie"></i> -->
                  <i class="las la-cube"></i>
                </div>
                <div class="top-menu__title"> Snapshot </div>
              </div>
            </li>
            <li class="am-item">
              <div class="top-menu"
                :class="activeTab === 'anonymous-message' ? 'top-menu--active' : ''"
                @click="dashboardTab = 'anonymous-message';onClickDashTab()"
              >
                <div class="top-menu__icon">
                  <!-- <i class="las la-chart-pie"></i> -->
                  <i class="lar la-comments"></i>
                </div>
                <div class="top-menu__title"> Messages </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- <div class="filter-bar"
          v-if="activeTab === 'disengaged-snapshot'
            || activeTab === 'disengaged-emp-to-meet'
            || activeTab === 'disengaged-sentiment-analysis'"
        >
          <v-btn
            class="box-container zoom-in mx-2"
            @click="dashboardTab = 'disengaged-snapshot'"
            :color="activeTab === 'disengaged-snapshot' ? 'primary' : ''"
          >
            Snapshot
          </v-btn>
          <v-btn
            class="box-container zoom-in mx-2"
            @click="dashboardTab = 'disengaged-emp-to-meet'"
            :color="activeTab === 'disengaged-emp-to-meet' ? 'primary' : ''"
          >
            Employees to meet
          </v-btn>
          <v-btn
            class="box-container zoom-in mx-2"
            @click="dashboardTab = 'disengaged-sentiment-analysis'"
            :color="activeTab === 'disengaged-sentiment-analysis' ? 'primary' : ''"
          >
            Sentiment analysis
          </v-btn>
        </div> -->
        <!-- <div class="filter-bar"
          v-if="activeTab === 'anonymous-snapshot' || activeTab === 'anonymous-message'"
        >
          <v-btn
            class="box-container zoom-in mx-2"
            @click="dashboardTab = 'anonymous-snapshot'"
            :color="activeTab === 'anonymous-snapshot' ? 'primary' : ''"
          >
            Snapshot
          </v-btn>
          <v-btn
            class="box-container zoom-in mx-2"
            @click="dashboardTab = 'anonymous-message'"
            :color="activeTab === 'anonymous-message' ? 'primary' : ''"
          >
            Messages
          </v-btn>
        </div> -->
      </div>

      <div
        v-if="activeTab === 'overview'"
        class="dash-overview"
      >
        <overview
          v-show="!isLoading"
          :dashboardData="dashboardData"
          :loadingDashboard="isLoading"
        ></overview>
        <amara-loader
          v-show="isLoading"
        ></amara-loader>
      </div>

      <div
        class="touchpoints-snapshot"
        v-if="activeTab === 'touchpoints-snapshot'"
      >
        <touchpoint-snapshot ref="touchpointsSnapshot"></touchpoint-snapshot>
      </div>

      <div
        class="touchpoints-analysis"
        v-if="activeTab === 'touchpoints-analysis'"
      >
        <touchpoint-Analysis ref="touchpointsAnalysis"></touchpoint-Analysis>
      </div>

      <div
        class="disengaged-snapshot"
        v-if="activeTab === 'disengaged-snapshot'"
      >
        <disengaged-Snapshot ref="disengagedSnapshot"></disengaged-Snapshot>
      </div>

      <div
        class="disengaged-emp-to-meet"
        v-if="activeTab === 'disengaged-emp-to-meet'"
      >
        <disengaged-EmpToMeet ref="disengagedEmpToMeet"></disengaged-EmpToMeet>
      </div>

      <div
        class="disengaged-sentiment-analysis"
        v-if="activeTab === 'disengaged-sentiment-analysis'"
      >
        <disengaged-SentimentAnalysis ref="disengagedSentimentAnalysis"></disengaged-SentimentAnalysis>
      </div>

      <div
        class="txt-analysis"
        v-if="activeTab === 'txt-analysis'"
      >
        <text-Analysis ref="txtAnalysis"></text-Analysis>
      </div>

      <div
        class="anonymous-snapshot"
        v-if="activeTab === 'anonymous-snapshot'"
      >
        <anonymous-Snapshot></anonymous-Snapshot>
      </div>

      <div
        class="anonymous-message"
        v-if="activeTab === 'anonymous-message'"
      >
        <anonymous-Message></anonymous-Message>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import AmaraLoader from '../elements/amara-loader';

import DashboardTopBar from './dashboard-top-bar';
import DashboardFilters from './dashboard-filters';
import Overview from './overview/overview';

import TouchpointSnapshot from './touchpoints/snapshot';
import TouchpointAnalysis from './touchpoints/analysis';

import DisengagedSnapshot from './disengaged/snapshot';
import DisengagedEmpToMeet from './disengaged/emp-to-meet';
// import DisengagedSentimentAnalysis from './disengaged/sentiment-analysis';
import DisengagedSentimentAnalysis from './disengaged/sentiment-analysis';

import TextAnalysis from './txt-analysis/analysis';

import AnonymousSnapshot from './anonymous/anonymous-snapshot';
import AnonymousMessage from './anonymous/anonymous-message';

export default {
  name: 'dashboard',

  components: {
    AmaraLoader,
    DashboardTopBar,
    DashboardFilters,
    Overview,
    TouchpointSnapshot,
    TouchpointAnalysis,
    DisengagedSnapshot,
    DisengagedEmpToMeet,
    DisengagedSentimentAnalysis,
    TextAnalysis,
    AnonymousSnapshot,
    AnonymousMessage
  },

  data () {
    return {
      // filterApplied: false,
      driverBreakdown: [],
      activeTab: '',
      isFilterApplied: false,
      dashboardTab: '',
      dashboardData: {},
      isLoading: true
    };
  },

  watch: {
    $route () {
      if (!this.checkPermission(['company_culture_dashboard'])) {
        this.$router.push('/ad-hoc');
      }
      if (this.$route.query) {
        if (this.$route.query.tab) {
          this.activeTab = this.$route.query.tab;
          this.dashboardTab = this.activeTab;
        }
      }
    },
    activeTab () {
      if (this.activeTab === 'overview' && this.checkPermission(['company_culture_dashboard'])) {
        this.getDashboardReport();
      }
    }
  },

  created () {
    // this.getDashboardReport();
  },

  beforeMount () {
    // console.log(this.checkPermission(['company_culture_dashboard']));
    if (!this.checkPermission(['company_culture_dashboard'])) {
      this.$router.push('/ad-hoc');
    }
    if (this.$route.query) {
      if (this.$route.query.tab) {
        this.activeTab = this.$route.query.tab;
      }
    }
    if (this.$route && this.$route.query && this.$route.query.filters) {
      const dashboardFilters = JSON.parse(this.$route.query.filters);
      this.$store.dispatch('updateDashboardFilters', dashboardFilters);
    } else {
      this.$store.dispatch('updateDashboardFilters', {});
    }
  },

  computed: {
    ...mapState({
      user: state => state.user,
      tabPermission: state => state.tabPermission,
      dashboardFilters: state => state.dashboardFilters,
      updateDashboardFilters: state => state.updateDashboardFilters
    })
  },

  methods: {
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    onClickDashTab () {
      // console.log('onClickDashTab', this.dashboardTab);
      const t = { ...this.$route.query };
      delete t.snapshot;
      const queryParams = {
        ...t,
        tab: this.dashboardTab
      };
      this.$router.push({
        path: '/',
        query: queryParams
      }).catch(() => {});
    },
    toggleDashFilter () {
      this.$refs.DashboardFilters.showFilterDrawer = true;
    },
    getRandomColor (driver) {
      let color = 'lightgrey';
      const colors = [
        '#eadf59',
        '#ff9800',
        '#37b99c',
        '#f44336',
        '#b56fea',
        '#0f4c1c',
        '#918ce7'
      ];
      color = colors[Math.floor(Math.random() * colors.length)];
      if (driver) {
        switch (driver) {
          case 'Culture':
            color = '#66c088';
            break;
          case 'Leadership':
            color = '#757575';
            break;
          case 'RewardsAndRecognition':
            color = '#495b69';
            break;
          case 'WorklifeIntegration':
            color = '#f06362';
            break;
          case 'CareerOpportunities':
            color = '#636363';
            break;
          case 'PerformanceManagement':
            color = '#43c5f1';
            break;
          default:
            break;
        }
      }
      return color;
    },
    // disengagedEmployeesType (type) {
    //   if (type === 'open') {
    //     this.actionStatusType = 'open,scheduled,acknowledged,inProgress';
    //   }
    //   if (type === 'resolved') {
    //     this.actionStatusType = 'resolved';
    //   }
    //   if (!type) {
    //     this.actionStatusType = '';
    //   }
    // },
    viewDriverWithFilter (driver) {
      this.$router.push({ path: `/driver/view/${driver}` });
    },
    getDashboardReport () {
      // const that = this;
      this.isLoading = true;
      const filters = Object.assign({}, this.updateDashboardFilters);
      if (filters && filters.filters) {
        // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      const queryParams = {
        fields: 'overall_mood,engagement_score,disengaged_employees_stats,company_employee_reach_stats,chat_response_stats,chat_response_trends,user_participation_stats,user_participation_trends,drivers_analysis,sub_drivers_analysis,company_mood_breakdown,monthwise_engagement_vs_mood_trend',
        ...filters
      };
      if (this.updateDashboardFilters && this.updateDashboardFilters.filters) {
        this.$lodash.each(this.updateDashboardFilters.filters, (v, k) => {
          if (v.length > 0) {
            queryParams[`user__profile__${k}__in`] = v.join();
          }
        });
      }
      axios.get(`${process.env.VUE_APP_API_URL}company/dashboard`, {
        params: queryParams
      }).then((response) => {
        if (response.status === 200) {
          this.dashboardData = response.data;
          this.$nextTick(() => {
            if (this.checkPermission(['company_culture_dashboard'])) {
              this.isLoading = false;
            } else {
              this.isLoading = true;
            }
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
          throw new Error(response);
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
        }
      });
    },
    updateEmployeeWithFilter (mood) {
      // const filters = Object.assign({}, this.filters.selected);
      const filters = Object.assign({}, this.updateDashboardFilters);
      // if (filters && filters.activeTab) {
      //   delete filters.activeTab;
      // }
      const employeeFilters = {
        mood__in: mood,
        // user_session__initiated_date_start: this.dateRangeOptions.startDate ? dayjs(this.dateRangeOptions.startDate).format('YYYY-MM-DD') : undefined,
        // user_session__initiated_date_end: this.dateRangeOptions.startDate ? dayjs(this.dateRangeOptions.endDate).format('YYYY-MM-DD') : undefined,
        // dynamic filters
        ...filters
      };
      this.$store.dispatch('updateEmployeeFilters', employeeFilters);
      this.$router.push({
        path: '/employees'
      });
    },
    // dashFiltersApplied (val) {
    //   this.isFilterApplied = val;
    // },
    filterApplied (val) {
      // console.log('filterApplied -> val', val);
      if (val) {
        this.isFilterApplied = val;
      }
      // if (this.isFilterApplied) {
      if (this.activeTab === 'overview' && this.checkPermission(['company_culture_dashboard'])) {
        this.getDashboardReport();
      }
      if (this.activeTab === 'touchpoints-snapshot') {
        this.$refs.touchpointsSnapshot.getStages();
      }
      if (this.activeTab === 'touchpoints-analysis') {
        this.$refs.touchpointsAnalysis.getTable();
      }
      if (this.activeTab === 'disengaged-snapshot') {
        this.$refs.disengagedSnapshot.getOverview();
      }
      if (this.activeTab === 'disengaged-emp-to-meet') {
        this.$refs.disengagedEmpToMeet.getAdminUsers();
        this.$refs.disengagedEmpToMeet.getEmployeesToMeet();
      }
      if (this.activeTab === 'disengaged-sentiment-analysis') {
        this.$refs.disengagedSentimentAnalysis.getData();
      }
      if (this.activeTab === 'txt-analysis' && this.$refs.txtAnalysis) {
        this.$refs.txtAnalysis.loadData();
      }
      // }
    },
    resetDashFilters () {
      this.isFilterApplied = false;
      // console.log('resetDashFilters -> this.$route.query', this.$route.query);
      this.$store.dispatch('updateDashboardFilters', null);
      const queryParams = {};
      queryParams.tab = this.$route.query.tab || 'overview';
      this.$router.push({
        path: '/',
        query: queryParams
      }).catch(() => {});
      this.filterApplied();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.dashboard-wrap {
  .dash-topbar {
    padding: 16px 12px 0px 12px;
    background: rgb(52,43,126);
    // background: #584475;
    background: #050550;
    background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
  }
  .dashboard-container {
    // background-color: var(--bg-panel);
    background-color: var(--bg);
    .dash-action-bar {
      // margin-bottom: 16px;
      &.active-border {
        border-bottom: 2px solid rgba(0,0,0,0.1);
      }
      .filter-bar {
        // background-color: var(--bg-panel);
        background-color: var(--bg);
        &.active {
          // margin-bottom: 16px;
        }
      }
      ul {
        padding-left: 50px !important;
        li {
          cursor: pointer;
          margin: 8px 0;
          padding: 0 16px;
        }
        .am-item {
          padding-left: 16px;
          border-left: 1px solid rgba(0, 0, 0, 0.4);
        }
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        .top-menu {
          display: flex;
          color: var(--color-text);
          position: relative;
          .top-menu__title {
            display: flex;
            align-items: center;
            white-space: nowrap;
            font-weight: var(--heading-weight);
            font-size: var(--content-size);
            .top-menu__sub-icon {
              transition-property: background-color,
              border-color, color, fill, stroke, opacity, box-shadow, transform;
              transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
              transition-duration: 100ms;
              width: 1rem;
              height: 1rem;
            }
          }
          &.top-menu--active {
            .top-menu__icon {
              // color: var(--primary-color);;
            }
            .top-menu__title {
              // color: var(--primary-color);
              border-bottom: 2.5px solid #000;
            }
            // &::after {
            //   content: "";
            //   border-bottom: 2.5px solid #342b7e;
            //   width: 75%;
            //   position: absolute;
            //   bottom: 0px;
            //   right: 0;
            // }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.announcekit-widget {
  a {
    color: white !important;
    margin-left: -16px;
    margin-top: -16px;
  }
}
</style>

<style scoped>
.dash-overview {
  /* background-color: red; */
}
</style>
